import TopReviewedProductsLogo from './logo'
import {topReviewedProductsCA, topReviewedProductsUK} from './styles'

const baseConfig = {
  domainName: 'topreviewedproducts' as const,
  domainType: 'insider' as const,
  siteName: 'Top Reviewed Products',
  favicon: '/favicons/topreviewedproducts.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-8HBG088SYT',
    camelCaseUrl: 'TopReviewedProducts.co.uk',
    logo: <TopReviewedProductsLogo className="size-10 shrink-0 tablet:size-8" locale="uk" />,
    title: (category: string, count: string) =>
      `Top ${count} Best Reviewed ${category} in the UK | There's One Clear Winner | TopReviewedProducts.co.uk`,
    description: (_category?: string, _count?: string) =>
      `TopReviewedProducts.co.uk – Top UK reviews on thousands of products. Find the top-rated items at today's lowest prices, all in one place!`,
    styles: topReviewedProductsUK,
  },
  ca: {
    measurementId: 'G-QW389Y3HBM',
    camelCaseUrl: 'TopReviewedProducts.ca',
    logo: <TopReviewedProductsLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
    title: (category: string, count: string) =>
      `Top ${count} Best Reviewed ${category} in CA | There's One Clear Winner | TopReviewedProducts.ca`,
    description: (_category?: string, _count?: string) =>
      `TopReviewedProducts.ca – Top CA reviews on thousands of products. Find the top-rated items at today's lowest prices, all in one place!`,
    styles: topReviewedProductsCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
